import { IconButton } from '@coop/components';
import { HeartFilledIcon, HeartIcon } from '@coop/icons';
import { type FC, useState } from 'react';

import { useSingleFavorite } from '../../hooks/useFavouriteRecipes';
import A11yAnnouncer from '../A11yAnnouncer/A11yAnnouncer';

export interface FavoriteRecipeToggleProps {
    recipeId: string;
    recipeName: string;
    type: 'foodbox' | 'recipe';
}

const FavoriteRecipeToggle: FC<React.PropsWithChildren<FavoriteRecipeToggleProps>> = ({
    type,
    recipeId,
    recipeName,
}) => {
    const [a11yText, setA11yText] = useState<string | undefined>(undefined);

    const typeText = type === 'foodbox' ? 'paket' : 'recept';

    const { isFavourite, onFavouriteRecipeToggleClick, isLoading } = useSingleFavorite(
        recipeId,
        recipeName,
        () => setA11yText(`${recipeName} sparades`),
        () => setA11yText(`${recipeName} togs bort från sparade ${typeText}`),
    );

    const label = isFavourite
        ? `Ta bort från sparade ${typeText}, ${recipeName}`
        : `Spara ${typeText}, ${recipeName}`;

    return (
        <>
            <A11yAnnouncer text={a11yText} announcerName={`${type}TeaserAnnouncer_${recipeId}`} />
            <IconButton
                size={32}
                theme="white"
                icon={isFavourite ? HeartFilledIcon : HeartIcon}
                label={label}
                onClick={onFavouriteRecipeToggleClick}
                disabled={isLoading}
            />
        </>
    );
};

export default FavoriteRecipeToggle;
